import * as React from 'react';

import * as styles from './CommercialTitlePartsWrapper.css';

export const CommercialTitlePartsWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <span className={styles['title-parts-wrapper']}>{children}</span>;
};
